export enum ProfileIncludeEnum {
  projectProperties = 'projectproperties',
}
